import React from 'react'
import { Button, Paper, Box, TextField, Typography } from '@mui/material'


function ConfirmPopup({handleConfirm, handleCancel, name, onChange, title, confirmText, subtitle}) {
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* Overlay. TODO: Make sure interaction with rest of screen not possible while overlay is open */}
            <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }} onClick={handleCancel}></div>
            {/* Popup */}
            <Paper style={{  zIndex: 1000 }}>
            {/* Popup content */}
            <div style={{ padding: '15px', minWidth: '250px' }}>
                <Typography variant='h6' sx={{fontWeight: 'Regular', textAlign: 'center', fontSize: '18px'}}>{title}</Typography>
                <Typography variant='body-2' sx={{fontStyle: "italic", fontSize: '14px'}}>{subtitle}</Typography>
                <Box sx={{display: 'flex', marginTop: '15px', justifyContent: 'space-between'}}>
                    <Button onClick={handleCancel} variant="outlined">Cancel</Button>
                    <Button sx={{minWidth: '85px'}} onClick={handleConfirm} variant="contained" color="error">{confirmText}</Button>
                </Box>
            </div>
            </Paper>
        </div>
    )
}

export default ConfirmPopup